import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'tables': '[String]',
	'parameters': 'String'
};

export default gql(`
	query tables_updated_at( ${ HelperGraphql.createFields( fields ) } ) {
		tables_updated_at( ${ HelperGraphql.createVariables( fields ) } ){
			table
			updated_at
		}
	}
`);

